





import Vue from "vue";
import { VForm } from "vuetify/lib";
import { TemplateMixin } from "@/@shell/mixins/TemplateMixin";

export default Vue.extend({
  name: "base-form",
  mixins: [VForm, TemplateMixin],
});
